import Config from '../../config';
import { QueryKeys, useCustomQuery } from './index';
import { TWithValidationError } from '../../administration/clientAdministrationPage/shared/useUploadEntities';

type UseJobResultsParams = {
  jobId: string,
  enabled: boolean
}

export const useJobResults = ({
  jobId,
  enabled,
}: UseJobResultsParams) => useCustomQuery(
  [QueryKeys.jobs.JobMetadata, jobId],
  {
    url: Config.endpoints.FETCH_JOB_RESULTS.replace(':jobId', jobId),
    errorMessage: 'Fetching Job Results failed',
    defaultData: {},
    enabled: Boolean(jobId && enabled),
  });

type UseImportJobResultsParams = {
  jobId: string,
  enabled: boolean
}
export const useValidateJobResults = <T>({
  jobId,
  enabled,
}: UseImportJobResultsParams) => {
  const customQuery = useCustomQuery<{
    resultData: TWithValidationError<T>[]
  }>(
    [QueryKeys.jobs.JobMetadata, jobId],
    {
      url: Config.endpoints.FETCH_JOB_RESULTS.replace(':jobId', jobId),
      errorMessage: 'Fetching Job Results failed',
      defaultData: {
        resultData: [],
      },
      enabled: Boolean(jobId && enabled),
    });

  return {
    ...customQuery,
    data: customQuery.data?.resultData || [],
  };
};
